"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Hr_1 = require("../../defaults/Hr");
var _helpers_1 = require("../../helpers");
var _styled_1 = require("../../styled-components");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var HrElement = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  height: ", ";\n  width: 100%;\n  max-width: ", ";\n"], ["\n  background: ",
    ";\n  height: ",
    ";\n  width: 100%;\n  max-width: ",
    ";\n"])), function (_a) {
    var defaultCss = _a.defaultCss, dark = _a.dark, theme = _a.theme;
    if (typeof dark === 'object') {
        return _helpers_1.setFontColor(dark.tablet, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
    }
    return _helpers_1.setFontColor(dark, defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.color, theme);
}, function (_a) {
    var height = _a.height;
    return typeof height === 'string' ? height : height + "px";
}, function (_a) {
    var width = _a.width;
    return typeof width === 'string' ? width : width + "px";
});
var Hr = function (_a) {
    var _b = _a.height, height = _b === void 0 ? Hr_1.defaultHrConfig.height : _b, _c = _a.width, width = _c === void 0 ? Hr_1.defaultHrConfig.width : _c, _d = _a.margin, margin = _d === void 0 ? Hr_1.defaultHrConfig.margin : _d, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps;
    var cssToApply = __assign({ color: Hr_1.defaultHrConfig.color }, defaultCss);
    return (react_1.default.createElement(HrElement, __assign({ as: "hr", height: height, width: width, margin: margin, defaultCss: cssToApply }, nativeProps)));
};
exports.default = Hr;
var templateObject_1;
//# sourceMappingURL=Hr.js.map